__turbopack_context__.v({
  "alignLeft": "CityBreak-module__peRKWG__alignLeft",
  "avgLabel": "CityBreak-module__peRKWG__avgLabel",
  "badge": "CityBreak-module__peRKWG__badge",
  "body": "CityBreak-module__peRKWG__body",
  "card": "CityBreak-module__peRKWG__card",
  "cardImage": "CityBreak-module__peRKWG__cardImage",
  "cardTitle": "CityBreak-module__peRKWG__cardTitle",
  "departures": "CityBreak-module__peRKWG__departures",
  "divider": "CityBreak-module__peRKWG__divider",
  "dot": "CityBreak-module__peRKWG__dot",
  "dotActive": "CityBreak-module__peRKWG__dotActive",
  "dots": "CityBreak-module__peRKWG__dots",
  "footer": "CityBreak-module__peRKWG__footer",
  "header": "CityBreak-module__peRKWG__header",
  "headingBlock": "CityBreak-module__peRKWG__headingBlock",
  "imageLink": "CityBreak-module__peRKWG__imageLink",
  "imageWrap": "CityBreak-module__peRKWG__imageWrap",
  "mobileTab": "CityBreak-module__peRKWG__mobileTab",
  "mobileTabActive": "CityBreak-module__peRKWG__mobileTabActive",
  "price": "CityBreak-module__peRKWG__price",
  "priceBlock": "CityBreak-module__peRKWG__priceBlock",
  "section": "CityBreak-module__peRKWG__section",
  "sideNext": "CityBreak-module__peRKWG__sideNext",
  "sidePrev": "CityBreak-module__peRKWG__sidePrev",
  "slickSlide": "CityBreak-module__peRKWG__slickSlide",
  "slickWrap": "CityBreak-module__peRKWG__slickWrap",
  "slider": "CityBreak-module__peRKWG__slider",
  "standard-subheading": "CityBreak-module__peRKWG__standard-subheading",
  "tab": "CityBreak-module__peRKWG__tab",
  "tabActive": "CityBreak-module__peRKWG__tabActive",
  "tabsDesktop": "CityBreak-module__peRKWG__tabsDesktop",
  "tabsMobile": "CityBreak-module__peRKWG__tabsMobile",
  "titleLink": "CityBreak-module__peRKWG__titleLink",
  "topRow": "CityBreak-module__peRKWG__topRow",
  "viewDealsBtn": "CityBreak-module__peRKWG__viewDealsBtn",
  "viewDealsIcon": "CityBreak-module__peRKWG__viewDealsIcon",
});
